import localforage from 'localforage'
import ClientsService from '../api-services/clients.service'
import PartnersService from '../api-services/partners.service'
import EmployeesService from '../api-services/employees.service'
import ProvidersService from '../api-services/providers.service'
import CountiesService from '../api-services/counties.service'
import CitiesService from '../api-services/cities.service'
import ProductsService from '../api-services/products.service'
import store from '../store/index'
// import ContactsService from './api-services/contacts.service'
// import LocationsService from './api-services/locations.service'
// import Nivel1Service from './api-services/nivel1.service'
// import Nivel2Service from './api-services/nivel2.service'
// import Nivel3Service from './api-services/nivel3.service'

export function checkPermission () {
  createCookie('checked_perm', 1, 1)
  store.dispatch('userRequest')
}

export function syncClients () {
  ClientsService.getAllSync()
    .then((response) => {
      if (response.data.data.length > 0) {
        response.data.data = response.data.data.sort((a, b) => {
          let textA = ''
          let textB = ''
          if (a.company_name === null) {
            textA = (a.first_name || '').toUpperCase().trim() + (a.last_name || '').toUpperCase().trim()
          } else {
            textA = a.company_name.toUpperCase().trim()
          }
          if (b.company_name === null) {
            textB = (b.first_name || '').toUpperCase().trim() + (b.last_name || '').toUpperCase().trim()
          } else {
            textB = b.company_name.toUpperCase().trim()
          }
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
        })
        localforage.setItem('clients', response.data.data)
      }
    })
}

export function syncPartners () {
  PartnersService.getAllSync()
    .then((response) => {
      if (response.data.data.length > 0) {
        localforage.setItem('partners', response.data.data)
      }
    })
}

export function syncProviders () {
  ProvidersService.getAllSync()
    .then((response) => {
      if (response.data.data.length > 0) {
        localforage.setItem('providers', response.data.data)
      }
    })
}

export function syncEmployees () {
  EmployeesService.getAllSync()
    .then((response) => {
      if (response.data.data.length > 0) {
        localforage.setItem('employees', response.data.data)
      }
    })
}

export function syncCities () {
  CitiesService.getAllSync()
    .then((response) => {
      if (response.data.data.length > 0) {
        localforage.setItem('cities', response.data.data)
      }
    })
}

export function syncCounties () {
  CountiesService.getAllSync()
    .then((response) => {
      if (response.data.data.length > 0) {
        localforage.setItem('counties', response.data.data)
      }
    })
}

export async function syncProducts () {
  await ProductsService.getAllSync()
    .then((response) => {
      if (response.data.data.length > 0) {
        localforage.setItem('products', response.data.data).then((response) => {
          createCookie('synced', 1, 1)
          window.location.reload()
        })
      }
    })
}

export function syncWarehouses () {
  EmployeesService.getAllSyncWarehouses()
    .then((response) => {
      if (response.data.data.data.length > 0) {
        localforage.setItem('warehouses', response.data.data.data)
      }
    })
}

function createCookie (cookieName, cookieValue, daysToExpire) {
  let date = new Date()
  date.setTime(date.getTime() + (daysToExpire * 24 * 60 * 60 * 1000))
  document.cookie = cookieName + '=' + cookieValue + '; expires=' + date.toGMTString()
}

export function checkCookie (cookieName) {
  let name = cookieName + '='
  let allCookieArray = document.cookie.split(';')
  for (let i = 0; i < allCookieArray.length; i++) {
    let temp = allCookieArray[i].trim()
    if (temp.indexOf(name) === 0) {
      return true
    }
  }
  return false
}

export function syncForOffline () {
  syncPartners()
  syncClients()
  syncProviders()
  syncEmployees()
  syncCounties()
  syncCities()
  syncWarehouses()
  syncProducts()
}
